let wasm;
export function __wbg_set_wasm(val) {
    wasm = val;
}


function logError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        let error = (function () {
            try {
                return e instanceof Error ? `${e.message}\n\nStack:\n${e.stack}` : e.toString();
            } catch(_) {
                return "<failed to stringify thrown value>";
            }
        }());
        console.error("wasm-bindgen: imported JS function that was not marked as `catch` threw an error:", error);
        throw e;
    }
}

const lTextDecoder = typeof TextDecoder === 'undefined' ? (0, module.require)('util').TextDecoder : TextDecoder;

let cachedTextDecoder = new lTextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

let cachedUint8ArrayMemory0 = null;

function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

function _assertNum(n) {
    if (typeof(n) !== 'number') throw new Error(`expected a number argument, found ${typeof(n)}`);
}

function _assertBoolean(n) {
    if (typeof(n) !== 'boolean') {
        throw new Error(`expected a boolean argument, found ${typeof(n)}`);
    }
}
/**
 * @param {CanvasRenderingContext2D} ctx
 * @param {number} width
 * @param {number} height
 * @param {number} min_r
 * @param {number} max_r
 * @param {number} min_x
 * @param {number} max_x
 * @param {boolean} vertical
 * @param {number} m
 * @param {number} n
 */
export function draw(ctx, width, height, min_r, max_r, min_x, max_x, vertical, m, n) {
    _assertNum(width);
    _assertNum(height);
    _assertBoolean(vertical);
    _assertNum(m);
    _assertNum(n);
    wasm.draw(ctx, width, height, min_r, max_r, min_x, max_x, vertical, m, n);
}

export function __wbg_fillRect_c38d5d56492a2368() { return logError(function (arg0, arg1, arg2, arg3, arg4) {
    arg0.fillRect(arg1, arg2, arg3, arg4);
}, arguments) };

export function __wbg_floor_3206eb41fe582a22() { return logError(function (arg0) {
    const ret = Math.floor(arg0);
    return ret;
}, arguments) };

export function __wbg_log_0e8ddf1fb1eaaf6e() { return logError(function (arg0) {
    const ret = Math.log(arg0);
    return ret;
}, arguments) };

export function __wbg_max_0516851425d44529() { return logError(function (arg0, arg1) {
    const ret = Math.max(arg0, arg1);
    return ret;
}, arguments) };

export function __wbg_pow_35f95838ecd24e51() { return logError(function (arg0, arg1) {
    const ret = Math.pow(arg0, arg1);
    return ret;
}, arguments) };

export function __wbg_random_3ad904d98382defe() { return logError(function () {
    const ret = Math.random();
    return ret;
}, arguments) };

export function __wbindgen_init_externref_table() {
    const table = wasm.__wbindgen_export_0;
    const offset = table.grow(4);
    table.set(0, undefined);
    table.set(offset + 0, undefined);
    table.set(offset + 1, null);
    table.set(offset + 2, true);
    table.set(offset + 3, false);
    ;
};

export function __wbindgen_throw(arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
};

